'use client';

import styles from './OptionBackBar.module.scss';

export type OptionBackBarProps = {
  onGoBack: () => void;
};

function OptionBackBar({ onGoBack }: OptionBackBarProps) {
  return (
    <div className={styles.componentStyle}>
      <div className={styles.container}>
        <div className={styles.buttonWrapper}>
          <button type='button' className={styles.backButton} onClick={onGoBack}>
            戻る
          </button>
        </div>
      </div>
    </div>
  );
}

export default OptionBackBar;
